import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_ATTRIBUTE](state, payload) {
    state.attribute = payload;
  },
  [MutationsType.SET_ATTRIBUTES](state, payload) {
    state.attributes = payload;
  },
  [MutationsType.ADD_ATTRIBUTE](state, payload) {
    state.attributes.push(payload);
  },
  [MutationsType.UPDATE_ATTRIBUTE](state, payload) {
    let ind = (state.attributes || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.attributes, ind, payload);
  },
  [MutationsType.DELETE_ATTRIBUTE](state, payload) {
    let ind = (state.attributes || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) state.attributes.splice(ind, 1);
  },
};
